"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PICTURES_BUCKET = exports.ITEMS_TABLE = void 0;
exports.ITEMS_TABLE = 'ItemsTable';
exports.PICTURES_BUCKET = 'pictures-bucket';
